<div class="container" *ngIf="displayedTab">
  <img class="logo-default" src="assets/images/logo-color.png" alt="COSS">
  <img class="logo-aivancity logo-aivancity-color" src="assets/images/logo-aivancity-color.png" alt="aivancity">
  <img class="logo-aivancity logo-aivancity-white" src="assets/images/logo-aivancity-white.png" alt="aivancity">
  <div class="menu">
    <div class="menu-item" *ngFor="let tab of displayedTab">
      <ng-container *ngIf="!tab.disabled; else disabled">
      <a [routerLink]="tab.path"
         routerLinkActive="active"
      >
        <span class="icon coss-{{ tab.icon }}"></span>
        <span>{{ tab.label|translate }}</span>
      </a>
      </ng-container>
      <ng-template #disabled>
        <a href="#" class="disabled">
          <span class="icon coss-{{ tab.icon }}"></span>
          <span>{{ tab.label|translate }}</span>
        </a>
      </ng-template>
    </div>
  </div>
</div>
